import { Link } from "react-router-dom";

/**
 * One row of an upload's refusal list (XPEN-3590).
 *
 * Since XPEN-3618 its only caller is the offline notice (offline-expense-upload.js); the
 * upload screens use UploadRefusalList. A plain string is shown as is. A duplicate
 * refusal ({text, reportId}, see utils/expense-duplicate-message) also links to the other
 * expense account that already holds the receipt, when the server named one.
 *
 * @param {object} props
 * @param {object} props.data - The app store; data.t reads translations.
 * @param {string|{text: string, reportId: (string|null)}} props.error - The row to show.
 * @returns {React.ReactNode} The row content.
 */
const UploadErrorRow = ({ data, error }) => {
  if (typeof error === "string") return error;

  return (
    <>
      {error.text}
      {error.reportId && (
        <>
          {" "}
          <Link to={`/expenses_account/${error.reportId}`} className="alert-link">
            {data.t.read("expense_duplicate.open_report")}
          </Link>
        </>
      )}
    </>
  );
};

export default UploadErrorRow;
